import { render } from "./MessageModal.vue?vue&type=template&id=8f408876&scoped=true&ts=true"
import script from "./MessageModal.vue?vue&type=script&lang=ts"
export * from "./MessageModal.vue?vue&type=script&lang=ts"

import "./MessageModal.vue?vue&type=style&index=0&id=8f408876&scoped=true&lang=css"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f408876"]])

export default __exports__